// src/features/my-shift/MyShiftDialog.tsx
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import { MyShiftPanel } from "./MyShiftPanel";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** 受控弹窗壳：footer session import 它 + 一个 useState 控 open 即可 */
export function MyShiftDialog({ open, onOpenChange }: Props) {
  const { t } = useTranslation('shifts')
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-[960px] p-0 overflow-hidden flex flex-col"
        style={{ height: "min(85vh, 560px)" }}
      >
        {/* a11y: Radix Dialog 要求可访问标题，视觉隐藏，面板 header 已有视觉标题 */}
        <DialogTitle className="sr-only">{t('myShift.title')}</DialogTitle>
        {/* pr-12:给 DialogContent 右上角 absolute 关闭 X 让位,避免压住 Today */}
        <MyShiftPanel headerClassName="pr-12" />
      </DialogContent>
    </Dialog>
  );
}
